var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.66602 4.33325H12.3327V12.9999C12.3327 13.3681 12.0342 13.6666 11.666 13.6666H2.33268C1.96449 13.6666 1.66602 13.3681 1.66602 12.9999V4.33325ZM3.66536 2.33325V0.999919C3.66536 0.631729 3.96384 0.333252 4.33203 0.333252H9.66537C10.0336 0.333252 10.332 0.631729 10.332 0.999919V2.33325H13.6654V3.66659H0.332031V2.33325H3.66536ZM4.99805 1.6665V2.33317H8.99805V1.6665H4.99805ZM4.99805 7V11H6.33138V7H4.99805ZM7.66602 7V11H8.99935V7H7.66602Z",
    fill: "#F06548"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.3cad98bb68c6e0b0b04e86cd99e4eb29.svg";
export { ForwardRef as ReactComponent };